<template>
    <v-layout row justify-center>
        <v-dialog :value="visible" @input="$emit('switch')" max-width="500px">
            <v-card>
                <v-card-title primary-title class="title font-weight-bold error">Booking Suggestion Declined
                </v-card-title>
                <v-card-text>
                    <v-layout row style="text-align: center;margin: 10px">
                        <v-flex xs2>
                            <b>Captain</b>
                        </v-flex>
                        <v-flex xs4>
                            {{data.captain_name}}
                        </v-flex>
                        <v-flex xs2>
                            <b>Passenger</b>
                        </v-flex>
                        <v-flex xs4>
                            {{data.passenger_name}}
                        </v-flex>
                    </v-layout>
                    <v-layout row style="text-align: center;margin: 10px">
                        <v-flex xs2>
                            <b>Pickup</b>
                        </v-flex>
                        <v-flex xs4>
                            {{data.pick_up_location}}
                        </v-flex>
                        <v-flex xs2>
                            <b>status</b>
                        </v-flex>
                        <v-flex xs4>
                            {{data.status}}
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>

    export default {
        name: 'BookingSuggestionDialog',
        props: {
            data: {
                type: Object
            },
            visible: {
                type: Boolean,
                default: false
            }
        }
    }
</script>